exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".section[data-v-c5bbf6bc]{position:relative;width:100%;margin:0 auto;max-width:1440px;padding-bottom:0;overflow:hidden}.section .border-grid[data-v-c5bbf6bc]{position:absolute;height:100%;left:25%;right:25%;border-left:1px solid rgba(0,0,0,.05);border-right:1px solid rgba(0,0,0,.05)}.section .border-grid .inner-line[data-v-c5bbf6bc]{position:absolute;left:50%;height:100%;border-left:1px solid rgba(0,0,0,.05)}@media screen and (max-width:1100px){.section .border-grid[data-v-c5bbf6bc]{left:15%;right:15%}}@media screen and (max-width:900px){.section .border-grid[data-v-c5bbf6bc]{left:20px;right:20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c5bbf6bc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/SectionHome.vue
// module id = 63
// module chunks = 0